// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import type { History } from 'react-router-dom';
import { components, elements, colors, fonts, copy } from '@peachjar/components';
import { TextField } from '@material-ui/core';
import { css } from 'react-emotion';
import axios from 'axios';
import { get } from 'lodash';
import config from '../../../../config';

import UhOhTurtle from '../../../components/UhOhTurtle.svg';
import WhiteSpaceSvgWrapper from '../../../components/WhiteSpaceSvgWrapper';

// const { Quote } = elements;
const {
  FullSpread,
  ContentColumn,
  WhitespaceColumn,
  Notifications,
} = components;
const { ButtonPrimaryLarge } = components.Buttons;
const { jungle, prussian } = colors;
const { ProximaNova } = fonts;
const { Headline1, Paragraph } = elements.typography;
const { quotes } = copy;
const { notifySuccess, notifyError } = Notifications;

const passesRegex = regex => input => regex.test(input);
const isProbablyValidEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const isProbablyValidEmail = passesRegex(isProbablyValidEmailRegex);

const styles = {
  emailField: css`
    width: 100%;
    max-width: 450px !important;
  `,
};

type Props = {|
  +history: History,
  +previousPage: () => void,
|};

type State = {|
  verificationEmailAddress: string,
  wasEmailSent: boolean,
|};

class ExpiredTokenContainer extends Component<Props, State> {
  state = {
    verificationEmailAddress: '',
    wasEmailSent: false,
  };

  sendMagicLinkEmail = () =>
    axios(`${config.REACT_APP_API_BASE_URL}/auth/district/magic-link`, {
      method: 'POST',
      data: {
        email: this.state.verificationEmailAddress,
        path: '/onboarding/payment',
      },
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        this.setState({ wasEmailSent: true });
        this.props.onNotifySuccess('The verification email has been resent.');
      })
      .catch(err => {
        if (
          get(err, 'response.data.error.code') ===
          'request.security.authentication.failure.identity_not_found'
        ) {
          this.props.onNotifyError(
            'There is not a user account associated with that email address. Please try a different email.'
          );
        } else {
          this.props.onNotifyError(get(err, 'message'));
        }
      });

  handleFormInput = e => {
    this.setState({ [e.target.id]: e.target.value });
  };

  render() {
    const { previousPage, history } = this.props;
    const { wasEmailSent } = this.state;

    return (
      <FullSpread>
        <ContentColumn onClick={() => history.push('/onboarding')}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <Headline1>Uh oh!</Headline1>
            <Paragraph>
              The link you tried to use is expired. Please resend the
              verification email to receive a new one.
            </Paragraph>
            <TextField
              className={`mt-5 ${styles.emailField}`}
              id="verificationEmailAddress"
              data-testid="field-verificationEmailAddress"
              name="verificationEmailAddress"
              label="Verification Email Address"
              onChange={this.handleFormInput}
            />
            <ButtonPrimaryLarge
              data-testid="submit-resendVerificationEmail"
              className="mt-5"
              onClick={this.sendMagicLinkEmail}
              disabled={
                !isProbablyValidEmail(this.state.verificationEmailAddress) ||
                wasEmailSent
              }
            >
              {wasEmailSent ? (
                <span>Email sent</span>
              ) : (
                <span>Resend Verification Email</span>
              )}
            </ButtonPrimaryLarge>
          </div>
        </ContentColumn>
        <WhitespaceColumn>
          <WhiteSpaceSvgWrapper
            svg={<UhOhTurtle />}
            quote={quotes.duncan_lastsLongerThanACatVideo}
          />
        </WhitespaceColumn>
      </FullSpread>
    );
  }
}

const mapStateToProps = state => {
  const form = state.form.onboarding;
  const values = form && form.values;

  return {
    formValues: { ...values },
  };
};

const mapDispatchToProps = dispatch => ({
  onNotifySuccess: message => dispatch(notifySuccess(message)),
  onNotifyError: message => dispatch(notifyError(message)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ExpiredTokenContainer)
);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/ExpiredTokenContainer.jsx